import { useCallback, type ReactNode } from 'react';
import {
  useHtmlToReact,
  type ElementTransform,
} from '@/components/Common/HtmlToReact';

const DROP_TAGS = new Set(['style', 'script', 'link']);
// 레거시 content 의 줄바꿈 공백이 표 태그 바로 아래 남으면 React 경고
const TABLE_PARTS = new Set([
  'table',
  'colgroup',
  'thead',
  'tbody',
  'tfoot',
  'tr',
]);
const isBlankText = (node: ReactNode) =>
  typeof node === 'string' && !node.trim();

/** SERP 품의 저장 content(레거시 문서 포함) 그대로. 표 스타일은 양식별 Root 가 감싼다 */
const SerpContentSnapshot = ({
  content,
  transform: formTransform,
}: {
  content: string;
  /** 양식별 요소 교체(버튼 등). undefined 를 돌려주면 기본 처리 */
  transform?: ElementTransform;
}) => {
  const transform = useCallback<ElementTransform>(
    (ctx) => {
      const { tagName, children } = ctx;
      if (DROP_TAGS.has(tagName)) return null;
      const replaced = formTransform?.(ctx);
      if (replaced !== undefined) return replaced;
      if (TABLE_PARTS.has(tagName)) {
        const kept = children.filter((c) => !isBlankText(c));
        children.splice(0, children.length, ...kept);
      }
      return undefined;
    },
    [formTransform],
  );
  return <>{useHtmlToReact(content, { transform })}</>;
};

export default SerpContentSnapshot;
